import mixin from '../../mixins/Mixin';
export default function(editor, config = {}) {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  var filet;
  domc.addType('filet', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          'custom-name': 'Filet',
          config: JSON.stringify(config),
          tagName: 'div',
          selectable: true,
          resizable: {
            minDim: 1,
            step: 0.1,
            currentUnit: 1,
            autoHeight: true,
            tl: 0, // Top left
            tc: 1, // Top center
            tr: 0, // Top right
            cl: 0, // Center left
            cr: 0, // Center right
            bl: 0, // Bottom left
            bc: 1, // Bottom center
            br: 0, // Bottom right
          },
        },
      },
      {
        isComponent(el) {
          var result = '';
          if (el.tagName === 'div') {
            result = { type: 'filet' };
          }
          return result;
        },
      },
    ),
    view: defaultView.extend({
      initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
      },
      handleUpdate() {
        let tidesModel = editor
          .getComponents()
          .models.find(item => this.view && item.attributes.attributes.id === this.view.el.id);
        let localStorageComponents = JSON.parse(localStorage.getItem('gjs-components')).map(
          item => {
            if (this.view && item.attributes.id === this.view.el.id) {
              item = tidesModel;
            }
            return item;
          },
        );
        localStorage.setItem('gjs-js', editor.getJs());
        localStorage.setItem('gjs-html', editor.getHtml());
        localStorage.setItem('gjs-components', JSON.stringify(localStorageComponents));
      },
      getComponent() {
        this.model.set('config', JSON.stringify(mixin.methods.getLangCode('display-filet-plugin')));
        const comps = this.model.get('components');
        // Add a basic countdown template if it's not yet initialized
        const content = ``;
        if (comps.length === 0) {
          comps.reset();
          comps.add(content);
        } else {
          setTimeout(() => {
            this.model.set('components', content);
          }, 1000);
        }
      },
      render(...args) {
        defaultView.prototype.render.apply(this, args);
        this.updateClasses();
        if (this.el.getElementsByTagName('DIV').length === 0) {
          this.getComponent(filet);
        }
        return this;
      },
    }),
  });
}



// WEBPACK FOOTER //
// ./src/plugins/filet/components.js